export default __webpack_public_path__ + "static/media/a037-emailAddress-04.87578f6c.png";